import { ApplicantType, IApplicant } from "../applicants/IApplicant";
import ICaseSummary from "../case/ICaseSummary";
import IUser from "../user/IUser";

export enum ContactNotificationType {
    ApplicantUpdated = 'ApplicantUpdated',
    LossReportUpdated = 'LossReportUpdated',
    FileUploaded = 'FileUploaded',
    NewsArticlePublished = 'NewsArticlePublished'
}

export default interface IContactNotification {
    id: number;
    created: number;
    createdBy?: IUser;
    fileId?: string;
    type: ContactNotificationType;
    case?: ICaseSummary;
    applicant?: IApplicant;
    institution?: IApplicant;
    applicantType: ApplicantType;
    newsId?: number;
    isRead: boolean;
}